import {
  BackgroundSettingsV1,
  CameraSettingsV1,
  CharacterSettingsV1,
  LabelSettingsV1,
  PlaybackSettingsV1,
  ProjectFromAPI,
} from '../types';
import { transformProjectResponse } from './api-transforms';
import apiRequest from './apiRequest';

type CreateMotionPayload = {
  objectID: string; // characterInstanceID
  prompt: string;
  numFrames: number;
  moreVariations?: boolean;
  sceneSettings?: {
    backgroundSettings?: BackgroundSettingsV1;
    cameraSettings?: CameraSettingsV1;
    characterSettings?: CharacterSettingsV1;
    labelSettings?: LabelSettingsV1;
    playbackSettings?: PlaybackSettingsV1;
  };
  wsConnectionID?: string;
  wsHttpEndpoint?: string;
};

export default async function postProjectsMotion(
  projectID: string,
  payload: CreateMotionPayload,
) {
  const { data, error } = await apiRequest<{
    project: ProjectFromAPI;
  }>('mogen-orchestration', `/v2/projects/${projectID}/motion`, {
    method: 'POST',
    body: JSON.stringify(payload),
  });

  return {
    data: data ? transformProjectResponse(data.project) : undefined,
    error,
  };
}
